var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3 12.2C14.9311 12.2 12.2 14.9311 12.2 18.3V103.7C12.2 107.069 14.9311 109.8 18.3 109.8H103.7C107.069 109.8 109.8 107.069 109.8 103.7V18.3C109.8 14.9311 107.069 12.2 103.7 12.2H18.3ZM0 18.3C0 8.19319 8.19319 0 18.3 0H103.7C113.807 0 122 8.19319 122 18.3V103.7C122 113.807 113.807 122 103.7 122H18.3C8.19319 122 0 113.807 0 103.7V18.3Z",
    fill: "#D1D1D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.65 36.6C37.9655 36.6 36.6 37.9655 36.6 39.65C36.6 41.3345 37.9655 42.7 39.65 42.7C41.3345 42.7 42.7 41.3345 42.7 39.65C42.7 37.9655 41.3345 36.6 39.65 36.6ZM24.4 39.65C24.4 31.2277 31.2277 24.4 39.65 24.4C48.0723 24.4 54.9 31.2277 54.9 39.65C54.9 48.0723 48.0723 54.9 39.65 54.9C31.2277 54.9 24.4 48.0723 24.4 39.65Z",
    fill: "#D1D1D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0866 44.4866C83.4688 42.1045 87.3312 42.1045 89.7133 44.4866L120.213 74.9866C122.596 77.3688 122.596 81.2312 120.213 83.6133C117.831 85.9956 113.969 85.9956 111.587 83.6133L85.4 57.4267L22.6134 120.213C20.2312 122.596 16.3688 122.596 13.9866 120.213C11.6044 117.831 11.6044 113.969 13.9866 111.587L81.0866 44.4866Z",
    fill: "#D1D1D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageIcon);
export default __webpack_public_path__ + "static/media/uploadImageIcon.e3e2fff94d52ad656a4a91b9587cb9b7.svg";
export { ForwardRef as ReactComponent };